import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { apiHelper } from "../lib/ApiHelper";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
ModuleRegistry.registerModules([
    ClientSideRowModelModule
]);

import { LicenseManager } from "@ag-grid-enterprise/core";
import PRHLoader from "../lib/PRHLoader";
import { Label } from "react-bootstrap";
import { isEmptyObject } from "jquery";
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");

export default function BulkAgendaPopUp(props) {
    const [agendaValue, setagendaValue] = useState(null);
    const [rowData, setRowData] = useState(null);
    const [selectedISBN, setSelectedISBN] = useState([]);
    const gridApi = useRef(null);
    const [gridOptions,setgridOption] = useState({
        defaultColDef: {
            resizable: true,
            sortable: true,
        },
        animateRows: true,
        accentedSort: true,
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        onSelectionChanged: onSelectionChanged,
        rowSelection: 'multiple',
    },
    )

    const columnDefs = [
        { headerName: '', pinned: "left", width: 40, minWidth: 30, checkboxSelection: true, headerCheckboxSelection: true, suppressSizeToFit: true, filter: false, headerClass: "HeaderClassSource1", cellClass: "checkboxcell" },
        { headerName: "ISBN", field: "isbn", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 100 },
        { headerName: "Title", field: "title", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 150 },
        {
            headerName: "Agenda Section", field: "agendaSection", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 100
        },
        {
            headerName: "Author", field: "author", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 70
        },

        { headerName: "Status", field: "status", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 70 },

        {
            headerName: "SubStatus", field: "subStatus", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 100
        },
        {
            headerName: "Agenda Date", field: "agendaDate", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource  right-align", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;

            }, width: 80, cellClass: "cell-text-right"
        },
        {
            headerName: "Onsale Date", field: "onsaleDate", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;

            }, width: 80, cellClass: "cell-text-right"
        },
        {
            headerName: "Sales Status", field: "salesStatus", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 100
        },
        {
            headerName: "Format", field: "format", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 100
        },

    ];

    const changeData = (e) => {
        setagendaValue(e.target.value);
    }

    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    }
    const onGridReady = async (params) => {
        gridApi.current = params.api;
        await fetchRowData();
    };

    const updateClick = async () => {
        try {
            var res = await apiHelper.inventoryPostCall("setBulkAgendaSection", { ISBNs: selectedISBN, AgendaValue: agendaValue });
            if (res == true) {
              //  console.info(res);
                props.setisAgendaPopUp(false);
            } else {
                titleAlert("Update Failed.", "error", 'alert-agenda-update')
                //failed message
            }
        } catch (e){
            console.error("set bulk Agenda failed", e);
            titleAlert("Update Failed.", "error", 'alert-agenda-update')
        }
    }

    const clearAgenda = async () => {
        try {
            var res = await apiHelper.inventoryPostCall("setBulkAgendaSection", { ISBNs: selectedISBN, AgendaValue: null });
            console.info(res)
            if (res == true) {
              //  console.info(res);
                props.setisAgendaPopUp(false);
            } else {
                titleAlert("Update Failed.", "error", 'alert-agenda-update')
                //failed message
            }
        } catch (e){
            console.error("set bulk Agenda failed", e);
            titleAlert("Update Failed.", "error", 'alert-agenda-update')
        }
    }
    function onSelectionChanged() {
        const selectedRows = gridApi?.current?.getSelectedRows();
        if (selectedRows != null) {
            const isbnList = selectedRows.map(i => i.isbn);
            setSelectedISBN(isbnList);
        }
    }

    const fetchRowData = async () => {
        try {
            const isbns = props.ISBNList.filter(i => i.audience === props.audience).map(item => item.isbn);
            const data = await apiHelper.inventoryPostCall("getBulkAgendaSection", isbns);
            if (data) {
                setRowData(data);
            } else { setRowData([]); }
        } catch (e) {
            console.error("get bulk status failed", e);
        }
    }
    const titleAlert = (message, className = 'info', id) => {
        const statusAlertElement = document.getElementById(id);
        statusAlertElement.textContent = message;
        statusAlertElement.className = className;
    }

    useEffect(() => {
        if (rowData?.length > 0 && gridApi)
            gridApi.current.selectAll();
    }, [rowData])
 
    
    return (
        <>
            <div className="popup-overlay container-fluid">
                <div className="blk-popup"><button className="popup-close-btn " onClick={() => props?.setisAgendaPopUp(false)}></button>
                    <div className="blk-popup-content"  >
                        <Row className="popup-header left-align mt-0 pt-0">Update Agenda Section</Row>
                        <Row>
                            <Col className="flex-grow-1 mt-1" md={2}>

                                <label className="fw-bold">Agenda Section</label>
                                <select className="custom-input ml-0 ttl-select" name="TitleList" onChange={changeData} value={agendaValue || ''}>
                                    <option value='' disabled>select...</option>

                                    <option key="1 FL" value="1 FL">1 FL</option>
                                    <option key="2 FL Backup" value="2 FL Backup">2 FL Backup</option>
                                    <option key="3 BL" value="3 BL">3 BL</option>
                                    <option key="4 Other" value="4 Other">4 Other</option>
                                </select>

                            </Col>

                            <Col md={2}><br/>
                                <button className="ISBNSubmit" onClick={updateClick} disabled={!agendaValue || selectedISBN?.length < 1}>
                                    Update
                                </button>
                            </Col>
                            <Col md={4}><br />
                                <button className="ISBNSubmit" onClick={clearAgenda} disabled={selectedISBN?.length < 1}>
                                    Clear Agenda Section
                                </button>
                            </Col>
                            <Col md={2}>  <br/><span id="alert-agenda-update"></span></Col>
                        </Row>
                        <div className="ag-theme-balham" style={{ width: "100%", height: "60vh" }}>
                   
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnDefs}

                                gridOptions={gridOptions}
                                onGridReady={onGridReady}
                            ></AgGridReact>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}